import React from "react";
import ChatHistoryList from "features/dashboard/components/ChatHistoryList";

/**
 * Lucid's history as a popover, anchored under the control that opened it.
 * The chrome is the one every popover in the app wears; the list inside is
 * the same one the chat page's history column shows.
 *
 * `className` positions it (e.g. "left-2 top-full mt-1"); the parent must be
 * `relative`. A click outside or Escape closes it.
 */
export default function ChatHistoryPopover({ className = "left-0 top-full mt-1", onClose, ...listProps }) {
  return (
    <>
      <div className="fixed inset-0 z-[20]" onClick={onClose} aria-hidden />
      <div
        role="dialog"
        aria-label="Chat history"
        className={`absolute z-[21] flex max-h-[70vh] w-[360px] max-w-[calc(100%-1rem)] flex-col overflow-hidden rounded-lg border border-[color:var(--border-default)] bg-[color:var(--surface-raised)] shadow-token-lg ${className}`}
      >
        <ChatHistoryList onClose={onClose} {...listProps} />
      </div>
    </>
  );
}
